import React from 'react';
import { Box } from '@mui/material';
import MasterLayout from '../../components/AppLayout/MasterLayout';
import { spaces } from '../../assets/styles/themes/tokens';
import { useSelector } from 'react-redux';
import { selectUser } from '../../reducers/user.selectors';
import DashboardPageHeader from '../../components/DashboardPageHeader';
import useFetchDashboardSubjectsProducts from './hooks/useFetchDashboardSubjects';
import CoursesCarousel from '../../components/Dashboard/CoursesCarousel';
import SubjectCarousel from '../../components/Dashboard/SubjectCarousel';

const NewDashboardPage: React.FC = () => {
  const user = useSelector(selectUser);
  const subjects = useFetchDashboardSubjectsProducts();
  if (!user) return null;
  const hasSubjects = subjects.userSubjects.length !== 0;
  const initialSubjects = subjects.userSubjects.slice(0, 2);

  return (
    <MasterLayout forceNewNavigation>
      <Box sx={{
        paddingTop: spaces.md,
        paddingX: spaces.md,
        paddingBottom: spaces.xxxxl,
        display: 'flex',
        flexDirection: 'column',
        gap: spaces.lg,
      }}>
        <DashboardPageHeader firstName={user?.firstName} />
        { 
          hasSubjects && initialSubjects.map(subject => <SubjectCarousel key={subject.id} subject={subject} />) 
        }
        { subjects.defaultSubject && <SubjectCarousel subject={subjects.defaultSubject} /> }
        <CoursesCarousel />
      </Box>
    </MasterLayout>
  );
};

export default NewDashboardPage;

